/* global axios */
import ApiClient from './ApiClient';

class FunnelsAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(funnelData, withDefaultStages = false) {
    return axios.post(this.url, {
      ...funnelData,
      with_default_stages: withDefaultStages,
    });
  }

  update(id, funnelData) {
    return axios.patch(`${this.url}/${id}`, funnelData);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new FunnelsAPI();
